
export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  vessel: {
    button: {
      marginTop: 'sm',
      textColor: 'primary'
    },
    discount: {
      backgroundColor: 'primary',
      color: 'white',
      padding: '2xs',
      fontWeight: 'semibold',
      fontSize: 'xs',
      borderRadius: true
    }
  },
  data() {
    return {
      currentImage: this.product.image
    }
  },
  computed: {
    title() {
      return {
        tag: 'h4',
        html: this.product.name,
        fontWeight: 'semibold'
      }
    },
    image() {
      return {
        fit: 'contain',
        position: 'center',
        ratio: '16/9',
        ...this.currentImage
      }
    },
    detailsLink() {
      const products = this.$pagePath('products')
      return `${products}/${this.product.slug}`
    }
  },
  methods: {
    onMouseEnter() {
      if (this.product.images.length) {
        this.currentImage = this.product.images[0]
      }
    },
    onMouseLeave() {
      if (this.product.images.length) {
        this.currentImage = this.product.image
      }
    }
  }
}
